import * as i18n from "../i18n.ts";
import ApiServer from "../ApiServer.ts";


ApiServer["custom.forgotpasswordonepage"] = async function(form){
  var
    identifier = form.identifier.value;
  try{
    await ApiServer.log2forgotpassword2(identifier)
  }catch(e){
    //console.log(e)
  }
  const confirmContainer = document.getElementById('confirm-container');
  confirmContainer.style.display = '';
  const confirmContainerText = confirmContainer.querySelector('span');
  if(identifier.indexOf('@')===-1){
    confirmContainerText.innerHTML = i18n.get('fw3.changepassword.info_password_reset_kidaccount_email_sent');
  }else{
    confirmContainerText.innerHTML = i18n.get('fw3.changepassword.info_password_reset_email_sent');
  }

}
